export enum VehicleStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
}
